<template>
    <div>
        <el-row class="over">模拟考试结束</el-row>
        <el-row class="comenOn">您已完成本次模考，再接再厉!</el-row>
        <el-row></el-row>
        <el-row class="num">
            <el-col :span='4' :offset='8'>
                对题数：{{right}}
            </el-col>
            <el-col :span='4' :offset='2'>
                错题数：{{total - right}}
            </el-col>
        </el-row>
        <el-row class="btnGroup">
            <!-- <el-col :span='4' :offset='7'>
                <el-button class="btn" type="primary" @click="over">重新答题</el-button>
            </el-col> -->
            <!-- <el-col :span='4' :offset='3'> -->
                <el-button class="btn" type="primary" @click="goMyCourse">返回我的课程</el-button>
            <!-- </el-col> -->
        </el-row>
    </div>
</template>
<script>
export default {
    props:{
        right:{
            type:Number
        },
        total:{
            type:Number
        }
    },
    methods:{
        goMyCourse(){
            this.$router.push('/myCourse')
        }
    }
}
</script>
<style lang="stylus" scoped>
.over
    color #333333
    font-size 18px
    margin 51px 0 20px
    text-align center
.comenOn
    color #0173FF
    font-size 16px
    text-align center
.num
    margin-top 60px
.btnGroup
    margin-top 180px
    text-align center
    button 
        width 140px
        background-image $btnBg
        background-size 100% 100%
        font-weight normal
</style>


// WEBPACK FOOTER //
// src/components/my/exam/result.vue